/**
 * Composant Ajax Forms
 * Gère les formulaires avec soumission AJAX
 */

import { findLink, goto, logger } from '../../core/base.js';
import { csrfHeaders } from '../../core/csrf.js';

/**
 * Initialise les formulaires AJAX
 */
export function initAjaxForms() {
    document.querySelectorAll('form[data-ajax]').forEach(form => {
        const ajax = form.dataset.ajax;

        form.addEventListener('submit', (event) => {
            event.preventDefault();

            const action = form.getAttribute('action');
            const method = form.getAttribute('method');

            fetch(action, {
                headers: csrfHeaders(action, {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                method: method,
                body: new URLSearchParams(new FormData(event.target))
            }).then(resp => {
                switch (resp.status) {
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                        switch (ajax) {
                            case 'reload':
                                window.location.reload();
                                break;
                            case 'next':
                                resp.json().then(json => {
                                    const next = findLink(json.links, 'next');
                                    goto('.' + next);
                                });
                                break;
                            case 'reset':
                            default:
                                form.reset();
                        }
                        break;
                    case 400:
                        form.dataset.state = 'bad-request';
                        break;
                    case 404:
                        form.dataset.state = 'not-found';
                        break;
                    case 409:
                        form.dataset.state = 'conflict';
                        break;
                    default:
                        form.dataset.state = 'error';
                        break;
                }
            }).catch(err => {
                form.dataset.state = 'error';
                logger.error('AJAX form submission error:', err);
            });
        });
    });

    logger.debug('AJAX forms initialized');
}

// Auto-initialisation
document.addEventListener('DOMContentLoaded', initAjaxForms);
